export const normalizedCustomProfilePrefix = 'custom:';
export const customProfilePrefix = 'custom.';
export const PROFILE_TRANSLATION_PREFIX = 'profile.';
